import React, { CSSProperties, ReactNode } from 'react';
import './ClickableIcon.scss';

interface ClickableIconInterface {
  children: ReactNode;
  ariaLabel: string;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
  isLink?: boolean;
  href?: string;
}

const ClickableIcon = ({ children, ariaLabel, onClick, className = '', style, isLink = false, href = '' }: ClickableIconInterface) => {
  if (isLink) {
    return (
      <div className={`clickable-icon-anchor ${className}`} style={style}>
        <a href={href} target="_blank" rel="noreferrer noopener">
          {children}
        </a>
      </div>
    );
  }

  return (
    <button aria-label={ariaLabel} onClick={onClick} className={`clickable-icon-button ${className}`} style={style}>
      {children}
    </button>
  );
};

export default ClickableIcon;
